module.exports = __webpack_public_path__ + "img/tu03.86871507.jpg";